











































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {ReceiptExpensesPickingListTargetType, ReceiptExpensesType, ClearingDebtType} from "@/enums/type";

@Component({
  name: 'PrintReceiptExpense'
})
export default class extends mixins(CommonMixin) {
  @Prop() readonly receiptExpense!: ReceiptExpensePickingList;
  @Prop() readonly debts!: any;
  ReceiptExpensesPickingListTargetType = ReceiptExpensesPickingListTargetType;
  ReceiptExpensesType = ReceiptExpensesType;
  ClearingDebtType = ClearingDebtType;

  get bindingData() {
    if (this.getProp(this.receiptExpense, 'type') === ReceiptExpensesType.PickingListPay
        && this.getProp(this.receiptExpense, 'targetType') === ReceiptExpensesPickingListTargetType.Customer)
      return {
        title: 'Bảng kê trả tiền khách hàng',
        info: {
          label: 'Khách hàng',
          name: this.getProp(this.receiptExpense, 'targetCustomer.fullName'),
          totalMoney: this.getProp(this.receiptExpense, 'totalMoney')
        },
        sideConfirm: {
          postOfficeName: this.getProp(this.receiptExpense, 'createdBy.employee.postOffice.name'),
          targetName: this.getProp(this.receiptExpense, 'targetCustomer.fullName')
        }
      }

    else if (this.getProp(this.receiptExpense, 'type') === ReceiptExpensesType.PickingListPay
        && this.getProp(this.receiptExpense, 'targetType') === ReceiptExpensesPickingListTargetType.PostOffice)
      return {
        title: 'Bảng kê trả tiền bưu cục',
        info: {
          label: 'Bưu cục',
          name: this.getProp(this.receiptExpense, 'targetPostOffice.name'),
          totalMoney: this.getProp(this.receiptExpense, 'totalMoney')
        },
        sideConfirm: {
          postOfficeName: this.getProp(this.receiptExpense, 'createdBy.employee.postOffice.name'),
          targetName: this.getProp(this.receiptExpense, 'targetPostOffice.name')
        }
      }

    else if (this.getProp(this.receiptExpense, 'type') === ReceiptExpensesType.PickingListCollect
        && this.getProp(this.receiptExpense, 'targetType') === ReceiptExpensesPickingListTargetType.Customer)
      return {
        title: 'Bảng kê thu tiền khách hàng',
        info: {
          label: 'Khách hàng',
          name: this.getProp(this.receiptExpense, 'targetCustomer.fullName'),
          totalMoney: this.getProp(this.receiptExpense, 'totalMoney')
        },
        sideConfirm: {
          postOfficeName: this.getProp(this.receiptExpense, 'createdBy.employee.postOffice.name'),
          targetName: this.getProp(this.receiptExpense, 'targetCustomer.fullName')
        }
      }

    else if (this.getProp(this.receiptExpense, 'type') === ReceiptExpensesType.PickingListCollect
        && this.getProp(this.receiptExpense, 'targetType') === ReceiptExpensesPickingListTargetType.Employee)
      return {
        title: 'Bảng kê thu tiền nhân viên',
        info: {
          label: 'Nhân viên',
          name: this.getProp(this.receiptExpense, 'targetEmployee.fullname'),
          totalMoney: this.getProp(this.receiptExpense, 'totalMoney')
        },
        sideConfirm: {
          postOfficeName: this.getProp(this.receiptExpense, 'createdBy.employee.postOffice.name'),
          targetName: this.getProp(this.receiptExpense, 'targetEmployee.fullname')
        }
      }

    else if (this.getProp(this.receiptExpense, 'type') === ReceiptExpensesType.PickingListCollect
        && this.getProp(this.receiptExpense, 'targetType') === ReceiptExpensesPickingListTargetType.Partner)
      return {
        title: 'Bảng kê thu tiền đối tác',
        info: {
          label: 'Đối tác',
          name: this.getProp(this.receiptExpense, 'targetPartner.name'),
          totalMoney: this.getProp(this.receiptExpense, 'totalMoney')
        },
        sideConfirm: {
          postOfficeName: this.getProp(this.receiptExpense, 'createdBy.employee.postOffice.name'),
          targetName: this.getProp(this.receiptExpense, 'targetPartner.name')
        }
      }
    return null;
  }
}
